import cookie from 'vue-cookies'
import router from "@/router"
import {commit} from "lodash/seq";
const defineAbilityFromPermissions = (loginData, vm)=> {
    // const parsedToken = vm.$parsetoken(access_token)
    // const permissions = parsedToken.permissions;
    if (loginData) {
        const permissions = loginData.permissions;
        const isSuperUser = loginData.user.isSuperUser;
        const isManager = loginData.permissionUnits && loginData.permissionRooms
        let abilities = [{'subject': 'dashboard', 'action': 'read'}];
        if (isSuperUser) {
            abilities.push({'subject': 'permissions', 'action': 'read'})
            abilities.push({'subject': 'superuser', 'action': 'read'})
        }
        if (isManager) {
            abilities.push({'subject': 'receptionSections', 'action': 'read'})
        }
        if (loginData.unitPermissions || loginData.roomPermissions){
            abilities.push({'subject': '0790364492', 'action': 'read'})
        }
        // permissions.forEach(role => {
        permissions.forEach(permission => {
            const permission_split = permission.split('.');
            if (permission_split.length === 2) {
                abilities.push({'subject': permission_split[0], 'action': permission_split[1]})
            } else if (permission === 'manageAll') {
                abilities.push({'subject': 'all', 'action': 'manage'})
            }
        })
        return abilities;
    }
    return null
    // })

};
export default {
    SET_TOKEN(state, access_token) {

        state.token = access_token;
        // this._vm.$cookies.set('token', access_token)
        localStorage.setItem("token", access_token);
        // this._vm.$ability.update(JSON.parse(localStorage.getItem("abilityData")))
        // state.isExistAccessToken = !!localStorage.getItem('token')
        // state.isExistAccessToken = !!cookie.get('token')
        // // console.log(state.isExistAccessToken);
        // // console.log(!!localStorage.getItem("token"));
    },
    SET_USER(state, user) {
        state.user = user;
        // cookie.set('user', user);
        // state.user = localStorage.setItem('user', JSON.stringify(user));
    },
    SET_ABILITY(state, loginData) {
        // cookie.set('user', user);
        localStorage.setItem("abilityData", JSON.stringify(defineAbilityFromPermissions(loginData, this._vm)))
    },
    SET_isExistAccessToken(state) {
        // state.isExistAccessToken = !!cookie.get('token');
        state.isExistAccessToken = !!localStorage.getItem('token');
    },
    LOGIN_SUCCESS(state, current_user) {
        state.user = current_user;
        // this.commit('SET_USER', current_user)
        localStorage.setItem("user", JSON.stringify(current_user));
    },
    // LOGOUT(state) {
    //     // cookie.remove("token");
    //     // cookie.remove("user");
    //     localStorage.removeItem("token");
    //     localStorage.removeItem("user");
    //     state.token = null;
    //     state.user = null;
    //     router.push({name:'login'})
    // },
    SET_PASSWORD(state, password) {
        state.password = password;
    },
    SET_OLD_PASSWORD(state, oldPassword) {
        state.oldPassword = oldPassword;
    },
    SET_CONFIRMATION(state, confirmation) {
        state.confirmation = confirmation;
    },
}

